import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "../../assets/icons/Tooltip";
import SubscriptionMarkDone from "../../assets/icons/SubscriptionMarkDone";
import { formatMoney } from "../../utils";
import { Button } from "../common";
import { useTranslation } from "react-i18next";
import FreeIcon from "../../assets/icons/Sparkle";
import BasicIcon from "../../assets/icons/Basic";
import PremiumIcon from "../../assets/icons/Premium"
import NewCheckIcon from "../../assets/icons/NewCheckIcon"
import OrangeCheckIcon from "../../assets/icons/OrangeCheckIcon"
import GreenCheckIcon from "../../assets/icons/GreenCheckIcon"


interface PricingPlanProps {
  title: string;
  duration: string;
  price: number;
  subPrice?: number;
  features: { name: string; tooltip?: string }[];
  buttonText: string;
  index: number;
  plan: string;
  show: (plan: string) => void;
  discount?: string;
}

const PricingPlan: React.FC<PricingPlanProps> = ({
  title,
  price,
  features,
  buttonText,
  index,
  show,
  plan,
  duration,
  discount,
  subPrice,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const { t } = useTranslation("subscription");


  // Map the title to its corresponding icon
  const getPlanIcon = (title: string) => {
    switch (title) {
      case "Free plan":
        return <FreeIcon />;
      case "Basic plan":
        return <BasicIcon />;
      case "Premium plan":
        return <PremiumIcon />;
      default:
        return null; // Fallback if no match
    }
  };

  const getCheckIcon = (title: string) => {
    switch (title) {
      case "Free plan":
        return <NewCheckIcon/>;
      case "Basic plan":
        return <OrangeCheckIcon/>;
      case "Premium plan":
        return <GreenCheckIcon />;
      default:
        return null; // Fallback if no match
    }
  }
  
  return (
    <div
    className={`   pt-[42px] md:pb-20 md:h-[976px] pb-10 md:w-[307px] w-full flex flex-col  gap-4  md:justify-between md:items-center relative 
    ${index === 0 ? "md:rounded-l-3xl rounded-lg md:rounded-none border bg-white" : index === 2 ? " md:rounded-r-3xl rounded-lg md:rounded-none border bg-white" : " rounded-lg md:rounded-none border-b bg-gray-50"}`}
  >
      <div className="w-full ">
      <div className="flex flex-col justify-start items-start space-y-[34px] w-full border-b md:border-none pb-4 px-[18px]">
        <div className="w-full flex flex-col justify-start items-start ">
        <div className="flex items-center justify-between w-full">
          {getPlanIcon(title)}
        <p className={`text-[#084784]  px-2 py-1 rounded-md text-md ${index===1 ? "bg-[#BBDDFC]" : "bg-white"}`}>{index ===1 ? "Popular" : ""}</p>
        </div>
      <p className="text-[#2B2B2B] text-[20px]  mt-4">
            {title}{" "}
          </p>
        </div>

        <p className=" text-[#979797] lg:text-[16px] flex flex-col justify-start items-start md:h-[80px]">
          <span
            style={{ fontWeight: 600 }}
            className="lg:text-[25px] text-[#000]"
          >
            {formatMoney(price)}
          </span>
        
  {subPrice && subPrice > 0 && (
    <span className="lg:text-[14px]">
      <span className="line-through">{formatMoney(subPrice)}</span> {duration}
    </span>
  )}
        </p>

        <div className="text-[14px] w-full md:flex justify-center md:text-[16px] hidden ">
              <button
        onClick={() => show(plan)}
        disabled={index === 0}
        className={`w-full py-3 rounded-md transition-colors duration-300 ${
          index === 1 
            ? "bg-[#FF6702] hover:bg-orange-600 text-white" 
            : "bg-gray-100 mt-2 hover:bg-gray-200 text-black"
        }`}
      >
        {buttonText}
      </button>
    </div>


      </div>

        {/* <div className="text-white flex flex-row items-center justify-center">
          <SubscriptionMarkDone />
          <p className="text-[#2B2B2B] text-[20px]" style={{ fontWeight: 700 }}>
            {title}{" "}
            <span
              className="text-[#979797]"
              style={{ fontWeight: 400, marginLeft: "3px" }}
            >
              Plan
            </span>{" "}
          </p>
        </div> */}
        <ul className="space-y-[19px] mt-[20px] md:mt-[47px] px-[18px] ">
          {features.map((feature, index) => (
            <li key={index} className=" flex items-center md:gap-[15px] gap-[14px]">
              {getCheckIcon(title)}
              <div className="flex items-center gap-1 text-[#2B2B2B]">
                <p className="text-[13px] xl:text-[16px] leading-[19.2px] font-normal text-[#2B2B2B]">
                  {feature.name}
                </p>
                {/* {feature.tooltip && (
                  <div
                    className="cursor-pointer relative"
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <Tooltip />
                    {hoveredIndex === index && (
                      <div className="absolute w-[204px] z-20 left-[-5.7em]">
                        <div className="flex items-center justify-center">
                          <svg
                            width="18"
                            height="15"
                            viewBox="0 0 18 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 0L17.6603 15H0.339746L9 0Z"
                              fill="#FFF4C6"
                            />
                          </svg>
                        </div>
                        <div className="p-3 bg-[#FFF4C6] rounded-[4px] text-[12px] font-medium leading-[14.4px]">
                          {feature.tooltip}
                        </div>
                      </div>
                    )}
                  </div>
                )} */}
              </div>
            </li>
          ))}
        </ul>


        <div className="text-[14px] w-full flex md:hidden justify-center md:text-[16px] px-4 mt-6 ">
              <button
        onClick={() => show(plan)}
        disabled={index === 0}
        className={`w-full py-3 rounded-md transition-colors duration-300 ${
          index === 1 
            ? "bg-[#FF6702] hover:bg-orange-600 text-white" 
            : "bg-gray-100 mt-2 hover:bg-gray-200 text-black"
        }`}
      >
        {buttonText}
      </button>
    </div>
      </div>



      {index === 1 && (
        <div className="absolute left-[-2.5em] bottom-[-3.5em] z-10">
          <div className="flex items-center justify-center">
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M9 0L17.6603 15H0.339746L9 0Z" fill="#FFF4C6" />
            </svg>
          </div>
          {/* <div className="h-[59px] w-[394px] bg-[#FFF4C6] rounded-[12px] text-[#5B5B5B] font-medium leading-[19.2px] flex justify-center items-center">
            {t("subscription.mostPopular")}
          </div> */}
        </div>
      )}
    </div>
  );
};

export default PricingPlan;
